export const isHex = (colors: string[]): boolean => colors.some((color) => color.match(/^#/));
